import Constants from './constants';
import { stringify } from '../../../front/search-query';
import Geohash from 'latlon-geohash';

const Actions = {
    updateZoom : (zoom, center) => {
        return dispatch => {
            dispatch ({
                     type: Constants.UPDATE_ZOOM,
                     zoom: zoom,
                     center: center
                 });
        }
    },
    isChanging: (value) => {
        return dispatch => {
            dispatch({ type: Constants.IS_CHANGING, isChanging: value });
        }
    },
    setCurrentMarker: (id) => {
        return dispatch => {
            dispatch({type: Constants.SET_CURRENT_MARKER, currentMarkerSelected: id});
        };
    },
    mapChange : (filters, map) => {
        return dispatch => {
            //return {
            //            type: Constants.MAP_CHANGE,
            //            zoom: map.zoom,
            //        };
            filters.zoom = map.zoom;
            filters.topLeftLatitude = map.bounds.nw.lat;
            filters.topLeftLongitude = map.bounds.nw.lng;
            filters.bottomRightLatitude = map.bounds.se.lat;
            filters.bottomRightLongitude = map.bounds.se.lng;
            const url = Routing.generate('search_api', {query: stringify(filters)});
            $.ajax({
                url: url,
                contentType: 'application/json',
                cache: false,
                method: 'GET',
                success: (data) => {
                   
                    const clusters  = data.clusters.map((cluster) => {
                            const hash = Geohash.decode(cluster.hash);
                          
                            return {
                                latitude : hash.lat,
                                longitude : hash.lon,
                                quantity : cluster.quantity
                            };
                        });
                    const villas = data.villas;
                        
                    dispatch ({
                        type: Constants.MAP_CHANGE,
                        center: map.center,
                        zoom: map.zoom,
                        villas: villas,
                        clusters: clusters
                    });
                    dispatch ({ type: Constants.IS_CHANGING, isChanging: false });
                    
                },
                error: (xhr, status, err) => {
                    var error = JSON.parse(xhr.responseText);
                    dispatch ({ type: Constants.IS_CHANGING, isChanging: false });
                }
            });
        };
    },
    updateSearch : (params) => {
        return dispatch => {
            dispatch ({
                type: Constants.UPDATE_SEARCH,
                villas: params.villas,
                clusters: params.clusters,
                filters: params.filters,
                center: params.center
            });
        }
    },
    showDetails : (villa) => {
        return dispatch => {
            dispatch({
                type: Constants.SET_VILLA_DATA,
                villaData: villa
            });
            dispatch({
                type: Constants.SHOW_DETAILS,
                showBlock: true
            });
        };
    },
    hideDetails : (villa) => {
        return dispatch => { 
            dispatch({
                type: Constants.HIDE_DETAILS,
                showBlock: false
            });
            dispatch({
                type: Constants.SET_VILLA_DATA,
                villaData: villa
            });
        };
    }
};

export default Actions
